module.exports = __webpack_public_path__ + "static/media/40.e1d4ed3a.mp3";